<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import FormSingleUpload from '../../../../app/components/form/SingleUpload.vue'
  import FormTinymce from '../../../../app/components/form/Tinymce.vue'
  import * as restfulService from '../../../services/restfulService'
  import DataService from '../../../services/dataService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required} from 'vuelidate/lib/validators'
  import bus from '@utils/bus'
  import baseConfig from '../../../../config'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton, FormSingleUpload, FormTinymce},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        form: {
          name: '',
          description: '',
          image: {
            name: '',
            type: '',
            size: '',
            base64: ''
          },
          image_back_page: {
            name: '',
            type: '',
            size: '',
            base64: ''
          },
          content: ''
        },
        dependencies: {},
        selectedSignature: []
      }
    },
    validations: {
      form: {
        name: {required},
        description: {required},
        image: {required},
        content: {required}
      }
    },
    mounted () {
      this.getDependencies()
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('layout', null, id, null, ['signatures'])
          .then(response => {
            const image = {
              name: response.image,
              type: '',
              size: '',
              base64: ''
            }
            response.image = image
            const imageBackPage = {
              name: response.image_back_page,
              type: '',
              size: '',
              base64: ''
            }
            response.image_back_page = imageBackPage
            this.form = response
            this.selectedSignature = response.signatures.map(item => item.id)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
      } else {
        this.isLoadingData = false
        bus.$emit('hide-loader')
      }
    },
    computed: {
      getLayoutImage: function () {
        return baseConfig.basePath + 'files/' + this.form.image.name
      },
      getLayoutImageBackPage: function () {
        return baseConfig.basePath + 'files/' + this.form.image_back_page.name
      }
    },
    methods: {
      getDependencies () {
        DataService.get([{domain: 'signature'}]).then((result) => {
          this.dependencies = result
        })
      },
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        data.signature = this.selectedSignature
        restfulService.save('layout', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'layout.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Layouts dos Certificados"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados do Layout</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-position="top"
                     @submit.native.prevent>
                <el-alert title="Dicas para Layout"
                          class="submission-tips layout-alert"
                          type="warning"
                          :closable="false">
                    <ul>
                        <li>O campo conteúdo deve conter o texto do certificado.</li>
                        <li>A imagem deve obrigatóriamemte obedecer as medidas de 1122 pixes de largura e 794 pixels de altura</li>
                        <li>Não se esquece de utilizar as variaveis para informações dinâmicas.</li>
                    </ul>
                </el-alert>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Nome"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.form.name.$error }">
                            <el-input v-model="form.name"
                                      @input="$v.form.name.$touch()"/>
                            <div class="el-form-item__error" v-if="$v.form.name.$error">Esse campo é obrigatório</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Descrição"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.form.description.$error }">
                            <el-input v-model="form.description"
                                      @input="$v.form.description.$touch()"/>
                            <div class="el-form-item__error" v-if="$v.form.description.$error">Esse campo é obrigatório</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="Conteúdo"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.content.$error }">
                    <el-input v-model="form.content"
                              @input="$v.form.content.$touch()"
                              type="textarea"
                              :rows="6"/>
                    <div class="el-form-item__error" v-if="$v.form.content.$dirty && $v.form.content.$error">Esse campo
                        é obrigatório
                    </div>
                </el-form-item>
                <el-row :gutter="20" class="layout-alert">
                    <el-col :span="12">
                        <el-alert
                                title="Dicas para formatação do texto:"
                                type="info"
                                :closable="false"
                                show-icon>
                            <ul>
                                <li>[ texto ] : entre colchetes ficará <b>negrito</b> </li>
                                <li>< texto > : entre setas ficará <i>itálico</i> </li>
                                <li>{ texto } : entre chaves ficará <u>sublinado</u> </li>
                            </ul>
                        </el-alert>
                    </el-col>
                    <el-col :span="12">
                        <el-alert
                                title="Para informações dinâmicas utilize:"
                                type="warning"
                                :closable="false"
                                show-icon>
                            <ul>
                                <li>$EVENTO_PRINCIPAL : nome do evento principal (Ex.: Congrega 2018) </li>
                                <li>$EVENTO : nome do evento (Ex.: MIC/Jornada) </li>
                                <li>$NOME : nome da pessoa (Autor/Participante) </li>
                                <li>$CARGA_HORARIA : carga horária do evento </li>
                                <li>$TITULO_TRABALHO: título do trabalho </li>
                                <li>$AUTORES : autores do trabalho </li>
                                <li>OBS¹ : Use apenas $TITULO_TRABALHO para certificados de submissão/apresentação de trabalho ou proposta de minicurso </li>
                                <li>OBS² : Use apenas $NOME ou $AUTORES para evitar duplicação</li>
                            </ul>
                        </el-alert>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Imagem Frente"
                                      class="is-required">
                            <form-single-upload :model.sync="form.image"
                                                accepted-types="image/*">
                            </form-single-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Imagem Verso">
                            <form-single-upload :model.sync="form.image_back_page"
                                                accepted-types="image/*">
                            </form-single-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Preview da Imagem Frente">
                            <div class="preview-image"
                                 v-if="form.image.name && !form.image.base64"
                                 :style="'background-image: url('+getLayoutImage+')'"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Preview da Imagem Verso">
                            <div class="preview-image"
                                 v-if="form.image_back_page.name && !form.image_back_page.base64"
                                 :style="'background-image: url('+getLayoutImageBackPage+')'"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="Assinaturas do Layout">
                    <el-transfer
                            v-model="selectedSignature"
                            :data="dependencies.signature"
                            :titles="['Disponíveis', 'Selecionados']"
                            :props="{
                                      key: 'id',
                                      label: 'name'
                                    }">
                    </el-transfer>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted"/>
                    <form-cancel-button route-name="layout.index"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<style lang="scss" scoped>
    .layout-alert {
        margin-bottom: 20px;
    }
    .preview-image {
        width: 400px;
        height: 300px;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        border: 1px solid #ddd;
    }
</style>



// WEBPACK FOOTER //
// Form.vue?424d86ae